import React, { useEffect, useState } from 'react';
import useResponsive from '../../../Hooks/useResponsive';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getRefundTrack } from '../../../redux/features/refundSlice';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Box, Paper, Stack, Typography } from '@mui/material';
import Loader3D from '../../../components/Loader/Loader3D';
import NoDataFound from '../../../components/NodataIndication/NoDataFound';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import ToolTip from '../../../components/ToolTip/ToolTip';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react/dist/iconify.js';
import { motion } from 'framer-motion';
import dayjs from 'dayjs';
const data = [
  {
    timestamp: '2025-11-25 11:14:25',
    remarks: 'Changes student status to Admission Confirmed',
    createdUser: 'MUHAMMED DILSHAD AT',
    action: 'Student status changed',
    sroAssignmentId: 150265,
    orderNo: 0,
  },
];
const RefundTrack = () => {
  const [direction, setDirection] = useState({});
  const mdUp = useResponsive('up', 'md');
  const [modifiedData, setModifiedData] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const refundId = queryParams.get('refundId');
  const dispatch = useDispatch();
  const { loading, refundTrack } = useSelector((store) => store.refund);

  useEffect(() => {
    if (refundId) {
      dispatch(getRefundTrack(refundId));
    }
  }, [refundId]);

  useEffect(() => {
    if (refundTrack.length > 0) {
      const modified = refundTrack.map((obj, index) => {
        const currentDate = dayjs(obj.timestamp).startOf('day'); // Start of day to focus only on the date
        const nextDate = refundTrack[index + 1] ? dayjs(refundTrack[index + 1].timestamp).startOf('day') : null;
        const daysGap = nextDate ? nextDate.diff(currentDate, 'day') : null;

        return {
          ...obj,
          daysGap: daysGap !== null && daysGap > 0 ? `${daysGap} days` : '0 day', // Set only if day has changed
        };
      });

      setModifiedData(modified);
    }
  }, [refundTrack]);
  return (
    <GlobalWrapper title={'Refund Track'}>
      <Box sx={{ width: mdUp ? '33%' : '100%' }}></Box>
      <Stack direction={direction} gap={2} sx={{ justifyContent: 'space-between' }}>
        <motion.div
          initial={{ opacity: 0, rotateY: 90 }}
          animate={{ opacity: 1, rotateY: 0 }}
          exit={{ opacity: 0, rotateY: 90 }}
          transition={{ duration: 1, ease: 'linear' }}
          style={{ flex: 2.5 }}
        >
          <Paper elevation={5}>
            {loading ? (
              <Loader3D />
            ) : refundTrack?.length === 0 ? ( //IF THE FETCHED DATA ARRAY LENGTH 0 THEN NO DATA TO DISPLAY SO DISPLAYING THIS COMPONENT
              <Box sx={{ height: '470px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <NoDataFound />
              </Box>
            ) : (
              <Box
                sx={{
                  p: 1,
                  height: '520px',
                  overflowY: 'auto',
                  paddingRight: '10px',
                  scrollbarWidth: 'thin',
                }}
              >
                <Box sx={{ p: mdUp ? 1 : 0 }}>
                  <Timeline position="alternate">
                    {modifiedData.map((data, index) => (
                      <TimelineItem key={index}>
                        <TimelineOppositeContent
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: index % 2 == 0 ? 'flex-end' : 'flex-start',
                            typography: 'body2',
                            color: 'gray',
                            fontSize: '0.9rem',
                            textAlign: 'right',
                            fontStyle: 'italic',
                            fontWeight: 'lighter',
                          }}
                        >
                          {index !== modifiedData.length - 1 ? data.daysGap : null}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot
                            variant="filled"
                            color="secondary"
                            sx={{
                              mx: '5px',
                              borderWidth: 4,
                              // borderColor: index % 2 === 0 ? 'gray' : 'black',
                              // backgroundColor: index % 2 === 0 ? 'black' : 'gray',
                              borderColor: 'black',
                              backgroundColor: 'gray',
                            }}
                          />
                          {index !== modifiedData.length - 1 && (
                            <TimelineConnector sx={{ backgroundColor: 'gray', width: 2 }} />
                          )}
                        </TimelineSeparator>
                        <TimelineContent
                          sx={
                            {
                              // py: '12px',
                              // backgroundColor: '#caf0f873',
                              // backgroundColor: '#e9ecef',
                              // borderRadius: 2,
                              // boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            }
                          }
                        >
                          <Typography
                            variant="h6"
                            component="span"
                            sx={{
                              fontWeight: 'bold',
                              color: 'black',
                              fontSize: '1.1rem',
                            }}
                          >
                            {data.action}
                          </Typography>
                          <Typography sx={{ fontSize: '0.85rem', color: 'text.secondary', mt: 1 }}>
                            {/* {dayjs(data.timestamp).format('DD-MM-YYYY')} */}
                            {data?.timestamp}
                          </Typography>
                          <Box sx={{ mt: 1 }}>
                            <Typography
                              component={'span'}
                              sx={{ color: '#03045e', fontSize: '0.9rem', backgroundColor: '#caf0f8', p: 1 }}
                            >
                              {`Handled by: ${data.createdUser || 'Not Mentioned'}`}
                            </Typography>
                          </Box>

                          <Box sx={{ mt: 2 }}>
                            <ToolTip
                              expand={data.remarks || 'Nill'}
                              content={
                                <Box
                                  component={'span'}
                                  border={1}
                                  sx={{
                                    borderRadius: '5px',
                                    px: 1,
                                    display: 'inline-flex',
                                    justifyContent: index % 2 !== 0 ? 'flex-end' : 'flex-start',
                                  }}
                                >
                                  Remarks
                                  <Icon icon="raphael:view" width="25" height="25" style={{ color: 'black' }} />
                                </Box>
                              }
                            />
                          </Box>

                          {/* {true && (
                            <Box sx={{ mt: 1 }}>
                             NEW THINGS
                            </Box>
                          )} */}
                        </TimelineContent>
                      </TimelineItem>
                    ))}
                  </Timeline>
                </Box>
              </Box>
            )}
          </Paper>
        </motion.div>

        {/* <Paper elevation={5} sx={{ flex: 1.2, mt: mdUp ? 0 : 10 }}>
          {loading ? (
            <Loader3D />
          ) : (
            <StudentProfile
              profilePic={profilePic}
              title={personalDetails?.name}
              subTitle={personalDetails?.place}
              personalDetails={personalDetails}
              otherDetails={otherDetails}
            />
          )}
        </Paper> */}
      </Stack>
    </GlobalWrapper>
  );
};

export default RefundTrack;
